/**
 * Documento impresso — design §7.
 *
 * Fica escondido na tela (`.so-impresso`) e aparece só no papel. Assim o
 * mesmo React que mostra o documento na tela imprime, sem gerar PDF no
 * servidor nem manter dois layouts que divergem.
 *
 * As regras que o §7 exige e que estão aqui: semântica vira TEXTO (cor não
 * sobrevive em preto e branco), mono e tabular-nums preservados, mobília de
 * página com "X de Y", e nada de zebra.
 */
import type { ReactNode } from "react";

export interface Emitente {
  nome: string;
  cnpj: string;
  filial: string;
  cidade: string;
  uf: string;
}

export function Impresso({
  emitente, titulo, numero, emissao, rodapeEsquerda, rodapeDireita,
  assinaturas, children,
}: {
  emitente: Emitente;
  titulo: string;
  numero: string;
  emissao: string;
  rodapeEsquerda?: string;
  rodapeDireita?: string;
  assinaturas?: string[];
  children: ReactNode;
}) {
  return (
    <div className="so-impresso doc-impresso">
      <div className="doc-cab">
        <div>
          <div className="emp">{emitente.nome}</div>
          <div className="det">
            CNPJ {emitente.cnpj} · {emitente.filial} · {emitente.cidade}/{emitente.uf}
          </div>
        </div>
        <div className="dir">
          {titulo.toUpperCase()} Nº {numero}<br />
          Emissão {emissao}<br />
          {/* Sem paginação automática em CSS puro; o navegador cuida da quebra
              e o cabeçalho repete por causa do display: table-header-group. */}
          Página 1
        </div>
      </div>

      {children}

      {(rodapeEsquerda || rodapeDireita) && (
        <div className="doc-pe">
          <span>{rodapeEsquerda ?? ""}</span>
          <span>{rodapeDireita ?? ""}</span>
        </div>
      )}

      {assinaturas && assinaturas.length > 0 && (
        <div className="doc-assinatura">
          {assinaturas.map((a) => <div key={a}>{a}</div>)}
        </div>
      )}
    </div>
  );
}

/**
 * Botão de imprimir.
 *
 * `window.print()` e não geração de PDF: o navegador já sabe paginar, e o
 * operador escolhe entre papel e "salvar como PDF" no próprio diálogo.
 */
export function BotaoImprimir({ rotulo = "Imprimir" }: { rotulo?: string }) {
  return (
    <button
      className="bt bt-neutro"
      style={{ padding: "4px 10px", fontSize: 12 }}
      onClick={() => window.print()}
    >
      {rotulo}
    </button>
  );
}

/** Status como TEXTO: em preto e branco a pílula colorida não diz nada (§7). */
export function situacaoImpressa(s: string): string {
  return s.toUpperCase();
}
